export const clientValidator = (clientData: any) => {
  return !!clientData;
};
